import SettingBase from '../settings/util/SettingBase'
class BranchController extends SettingBase {
  /*@ngInject*/
  constructor($state) {
    super();
    this.acl = {}
    this.hasACL = {}
    this.id = 'branch';
    this.$state = $state

  }
  $onInit() {
    super.$onInit()
    
    
    for (let key in this.acl['setting-' + this.id]) {
      this.hasACL[this.acl['setting-' + this.id][key]] = true;
    }
  }
}

export default BranchController;


// WEBPACK FOOTER //
// ./client/app/components/branch/branch.controller.js